import * as Sentry from "@sentry/browser";

/**
 * Initialise Sentry error tracking for the frontend.
 * Only initialises when FRONTEND_SENTRY_DSN is set.
 *
 * Direct `process.env.X` references are required so that Bun's bundler can
 * statically replace them with inlined values at build time.  A try-catch
 * guards against environments (e.g. browsers without a process polyfill)
 * where accessing `process.env` would throw a ReferenceError at runtime.
 */
export function initialiseSentry(): void {
  let dsn: string | undefined;
  let environment: string | undefined;

  try {
    dsn = process.env.FRONTEND_SENTRY_DSN;
    environment = process.env.ENVIRONMENT;
  } catch {
    // process is not available in this environment (e.g. browser without polyfill)
    return;
  }

  if (!dsn) {
    return;
  }

  Sentry.init({
    dsn,
    environment: environment ?? "development",
    integrations: [Sentry.browserTracingIntegration()],
    tracesSampleRate: 1.0,
  });
}
